export default __webpack_public_path__ + "static/media/ProgressiveBudget.9c4fa7cd.jpg";